import React, { ReactNode } from 'react';

interface TabContentProps {
  children: ReactNode;
  style: React.CSSProperties;
  testID: string;
}

/**
 * Content wrapper component for tab layout
 * Handles main content area styling and accessibility
 */
export const TabContent: React.FC<TabContentProps> = ({ 
  children, 
  style, 
  testID 
}) => {
  return (
    <main 
      className="tab-content"
      style={style}
      id="main-content"
      aria-label="Main content"
      data-testid={`${testID}-content`}
    >
      {children}
    </main>
  );
};